const sections = [
  {
    title: "Use of the platform",
    body:
      "Member Discovery is a curated directory for research purposes. Do not scrape or resell listings. Respect platform-specific rules before joining communities."
  },
  {
    title: "Submission policy",
    body:
      "Only authorized representatives may submit a guild or community. You confirm that your listing follows applicable community guidelines and local laws."
  },
  {
    title: "Disclaimer",
    body:
      "We provide discovery infrastructure, not moderation for external platforms. Participation is at your own discretion."
  },
  {
    title: "Updates",
    body:
      "These Terms may update without notice as the MVP evolves. Continued use means you accept the latest version."
  }
];

const Terms = () => (
  <div className="space-y-6">
    <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary">Terms of Service</p>
    <h1 className="text-4xl text-slate-100">Member Discovery Terms</h1>
    <section className="panel space-y-4 text-sm text-slate-300">
      {sections.map((section) => (
        <article key={section.title} className="space-y-2">
          <h2 className="text-xl text-slate-100">{section.title}</h2>
          <p>{section.body}</p>
        </article>
      ))}
    </section>
  </div>
);

export default Terms;
